'use strict';

module.exports = {
  ES6_RUNTIME_PATH: '/es6runtime.min.js',
  WIX_CODE_RUNTIME_PATH: '/all.min.js',
  DATA_BINDING: 'dataBinding',
  DEFAULT_WIX_CODE_PLATFORM: '//static.parastorage.com/services/wix-code-platform/1.11.0',
  REMOTE_DOM_URL: '//unpkg.parastorage.com/@shimil/remote-dom@5.0.0/dist/remote.min.js',
  SEMI_NATIVE_SDK_URL: 'http://static.parastorage.com/services/semi-native-sdk/1.3.0/lib/wix.min.js',
  LODASH: '//static.parastorage.com/unpkg/lodash@4.17.4/lodash.min.js'
};



// WEBPACK FOOTER //
// ./src/main/constants.js